(() => {
  const dialog = document.getElementById('HomePromoPopup');
  if (!dialog || typeof dialog.showModal !== 'function' || window.Shopify?.designMode) return;

  const close = () => dialog.close();
  dialog.querySelector('.home-promo-popup__close').addEventListener('click', close);
  dialog.querySelector('.home-promo-popup__link').addEventListener('click', close);
  dialog.addEventListener('click', (event) => {
    if (event.target !== dialog) return;
    const bounds = dialog.getBoundingClientRect();
    if (event.clientX < bounds.left || event.clientX > bounds.right ||
        event.clientY < bounds.top || event.clientY > bounds.bottom) close();
  });
  dialog.addEventListener('close', () => document.documentElement.classList.remove('home-promo-popup-open'));

  window.setTimeout(() => {
    dialog.showModal();
    document.documentElement.classList.add('home-promo-popup-open');
  }, 3000);
})();
